import { useEffect } from "react";

const SITE_URL = "https://varunmarbles.in";
const DEFAULT_TITLE = "Varun Marbles | Quartz, Marble, Granite & Onyx";
const DEFAULT_DESC =
  "Varun Marbles — premium quartz slabs, Italian & Indian marble, granite and onyx, curated for spaces built to be remembered.";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

export function useSeo({ title, description, path = "/" }) {
  useEffect(() => {
    const t = title || DEFAULT_TITLE;
    const d = description || DEFAULT_DESC;
    const url = `${SITE_URL}${path}`;
    document.title = t;
    upsertMeta("name", "description", d);
    upsertMeta("property", "og:title", t);
    upsertMeta("property", "og:description", d);
    upsertMeta("property", "og:url", url);
    upsertMeta("name", "twitter:title", t);
    upsertMeta("name", "twitter:description", d);
    upsertCanonical(url);
    return () => {
      document.title = DEFAULT_TITLE;
      upsertMeta("name", "description", DEFAULT_DESC);
    };
  }, [title, description, path]);
}
